import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../store/useStore.js";
const tabs = [
    { path: "/", label: "Home", icon: "⬡" },
    { path: "/squad", label: "Squad", icon: "◈" },
    { path: "/play", label: "Play", icon: "▶" },
    { path: "/inbox", label: "Inbox", icon: "✉" },
    { path: "/profile", label: "Profile", icon: "◉" },
];
export function BottomNav() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const inboxUnread = useStore(s => s.inboxUnread);
    return (_jsx("nav", { style: {
            display: "flex",
            borderTop: "1px solid #1e1e2e",
            background: "#0a0a0f",
            flexShrink: 0,
        }, children: tabs.map((tab) => {
            const isPlay = tab.path === "/play";
            const active = isPlay
                ? (pathname === "/play" || pathname === "/scout")
                : pathname === tab.path;
            const isInbox = tab.path === "/inbox";
            const showBadge = isInbox && inboxUnread > 0;
            return (_jsxs("button", { onClick: () => navigate(tab.path), style: {
                    flex: 1,
                    padding: "8px 4px 10px",
                    background: "none",
                    border: "none",
                    borderTop: active ? `2px solid #7c3aed` : "2px solid transparent",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                    color: active ? (isPlay ? "#a78bfa" : "#7c3aed") : "#334155",
                    fontSize: 10,
                    fontWeight: active ? 700 : 400,
                    transition: "color 0.15s, border-color 0.15s",
                    boxShadow: active ? "0 -1px 12px rgba(124,58,237,0.35)" : "none",
                    animation: active ? "tabGlow 2.5s ease-in-out infinite" : "none",
                    position: "relative",
                }, children: [_jsxs("span", { style: {
                            fontSize: isPlay ? 22 : 18,
                            filter: active
                                ? `drop-shadow(0 0 6px ${isPlay ? "#7c3aed" : "#7c3aedaa"})`
                                : "none",
                            transition: "filter 0.2s",
                            position: "relative",
                        }, children: [tab.icon, showBadge && (_jsx("span", { style: {
                                    position: "absolute",
                                    top: -2,
                                    right: -8,
                                    minWidth: 14,
                                    height: 14,
                                    borderRadius: 7,
                                    background: "#ef4444",
                                    color: "#fff",
                                    fontSize: 9,
                                    fontWeight: 800,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                    boxShadow: "0 0 6px #ef444488",
                                    fontFamily: "system-ui, sans-serif",
                                    lineHeight: 1,
                                    letterSpacing: 0,
                                }, children: inboxUnread > 99 ? "99+" : inboxUnread }))] }), _jsx("span", { style: { letterSpacing: active ? 0.5 : 0 }, children: tab.label })] }, tab.path));
        }) }));
}
